module.exports = __webpack_public_path__ + "img/phone-regis.c812252f.png";